import { formatCurrencyForDisplay } from '@utils'
import cn from 'classnames'
import { useCurrencies } from 'mmfintech-backend-api'
import { formatFloat } from 'mmfintech-commons'
import type { ReactNode } from 'react'

import styles from './AmountPreviewRow.module.scss'

type MainAmountRowProps = {
  label: ReactNode
  amount: number
  currency: string
  discountedAmount?: number
  showDiscount?: boolean
  className?: string
  'data-test'?: string
}

const AmountPreviewRow = (props: MainAmountRowProps) => {
  const { label, amount, currency, discountedAmount, showDiscount, className, 'data-test': dataTest } = props

  const hasDiscount = showDiscount ?? (discountedAmount !== undefined && discountedAmount !== null)

  const { getCurrencyPrecision } = useCurrencies()
  const precision = getCurrencyPrecision(currency)

  return amount > 0 ? (
    <div className={styles['amount-preview-wrapper']}>
      <div className='amount-preview-label'>{label}:</div>
      <div className={cn('amount-preview-value', className, { discounted: hasDiscount })}>
        <span data-test={dataTest ? `${dataTest}-value` : undefined}>{formatFloat(amount, precision)}</span>
        {currency ? (
          <span className='amount-preview-currency' data-test={dataTest ? `${dataTest}-currency` : undefined}>
            {formatCurrencyForDisplay(currency)}
          </span>
        ) : null}
      </div>
      {hasDiscount && (
        <div className='amount-preview-value'>
          <span data-test={dataTest ? `${dataTest}-value-discounted` : undefined}>
            {formatFloat(discountedAmount, precision)}
          </span>
          {currency ? (
            <span
              className='amount-preview-currency'
              data-test={dataTest ? `${dataTest}-currency-discounted` : undefined}
            >
              {formatCurrencyForDisplay(currency)}
            </span>
          ) : null}
        </div>
      )}
    </div>
  ) : null
}

export default AmountPreviewRow
